import beatBattleThemeIdeas from './beat-battle-theme-ideas';
import beatBattleVsRapBattle from './beat-battle-vs-rap-battle';
import bestFreeDawsForBeatmakers2026 from './best-free-daws-for-beatmakers-2026';
import bestOnlineBeatBattleSites from './best-online-beat-battle-sites';
import historyOfOnlineBeatBattles from './history-of-online-beat-battles';
import howProducerBattlesWork from './how-producer-battles-work';
import howToHostABeatBattle from './how-to-host-a-beat-battle';
import howToMakeATrapBeatIn30Minutes from './how-to-make-a-trap-beat-in-30-minutes';
import howToMixAn808 from './how-to-mix-an-808';
import howToStartBeatmaking from './how-to-start-beatmaking';
import howToWinABeatBattle from './how-to-win-a-beat-battle';
import onlineBeatBattlesCompleteGuide from './online-beat-battles-complete-guide';
import producerBattleVsBeatBattleNet from './producer-battle-vs-beat-battle-net';
import type { Post } from './types';
import whatIsABeatBattle from './what-is-a-beat-battle';

// Posts ordered newest first. Slug is the primary key (used in URLs).
export const POSTS: Post[] = [
  beatBattleThemeIdeas,
  producerBattleVsBeatBattleNet,
  historyOfOnlineBeatBattles,
  whatIsABeatBattle,
  bestOnlineBeatBattleSites,
  howToHostABeatBattle,
  beatBattleVsRapBattle,
  howToWinABeatBattle,
  bestFreeDawsForBeatmakers2026,
  onlineBeatBattlesCompleteGuide,
  howProducerBattlesWork,
  howToMakeATrapBeatIn30Minutes,
  howToMixAn808,
  howToStartBeatmaking,
];

export const POSTS_BY_SLUG: Record<string, Post> = Object.fromEntries(
  POSTS.map((p) => [p.meta.slug, p]),
);
